import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';
import WaveDivider from '../components/WaveDivider';

export default function KontaktPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <SEO
        title="Kontakt | JT transportsejlads"
        description="Har du spørgsmål eller kommentarer? Kontakt os i dag for at høre mere om, hvad vi kan gøre for dig."
        ogTitle="Kontakt | JT transportsejlads"
        ogDescription="Har du spørgsmål eller kommentarer? Kontakt os i dag for at høre mere om, hvad vi kan gøre for dig."
        ogImage="https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg"
      />

      {/* Page Header */}
      <section className="relative bg-maritime-950 text-white pt-32 pb-20 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-45">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg"
            alt="Kontakt JT transportsejlads"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-maritime-950 via-maritime-950/80 to-maritime-950/60" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white mb-6">
            Kontakt
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto">
            Har du spørgsmål eller kommentarer? Kontakt mig i dag for at høre mere om, hvad jeg kan gøre for dig.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href="tel:+4550510062"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">+45 50 51 00 62</span>
            </a>
            <a
              href="mailto:johann2@hotmail.com"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-envelope text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">johann2@hotmail.com</span>
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 inset-x-0">
          <WaveDivider fill="#f8fafc" />
        </div>
      </section>

      {/* Main Content: Info & Form */}
      <section className="py-16 sm:py-20 lg:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Left: Mine kontaktinformationer */}
            <div className="lg:col-span-5 space-y-8">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200/80 space-y-6">
                <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
                  Mine kontaktinformationer
                </h2>

                <div className="space-y-4 text-slate-700">
                  <div>
                    <span className="text-xs font-bold text-cyan-800 uppercase tracking-wider block mb-1">
                      Virksomhed
                    </span>
                    <p className="text-lg font-bold text-slate-900">JT transportsejlads</p>
                    <p className="text-sm text-slate-500">CVR nr.: 45455335</p>
                  </div>

                  <div className="pt-2 border-t border-slate-100">
                    <span className="text-xs font-bold text-cyan-800 uppercase tracking-wider block mb-1">
                      Adresse
                    </span>
                    <a
                      href="https://www.google.com/maps/place/Moesg%C3%A5rd%20All%C3%A9%205,%208320%20M%C3%A5rslet"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base text-slate-900 font-medium hover:text-cyan-700 transition-colors flex items-start gap-2"
                    >
                      <i className="fa-solid fa-location-dot text-cyan-600 mt-1" aria-hidden="true" />
                      <span>Moesgård Allé 5, 8320 Mårslet</span>
                    </a>
                  </div>

                  <div className="pt-2 border-t border-slate-100">
                    <span className="text-xs font-bold text-cyan-800 uppercase tracking-wider block mb-1">
                      Telefon
                    </span>
                    <a
                      href="tel:+4550510062"
                      className="text-lg font-bold text-slate-900 hover:text-cyan-700 transition-colors flex items-center gap-2 whitespace-nowrap"
                    >
                      <i className="fa-solid fa-phone text-cyan-600" aria-hidden="true" />
                      <span className="whitespace-nowrap">+45 50 51 00 62</span>
                    </a>
                  </div>

                  <div className="pt-2 border-t border-slate-100">
                    <span className="text-xs font-bold text-cyan-800 uppercase tracking-wider block mb-1">
                      Email
                    </span>
                    <a
                      href="mailto:johann2@hotmail.com"
                      className="text-base font-medium text-slate-900 hover:text-cyan-700 transition-colors flex items-center gap-2 whitespace-nowrap"
                    >
                      <i className="fa-solid fa-envelope text-cyan-600" aria-hidden="true" />
                      <span className="whitespace-nowrap">johann2@hotmail.com</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Scraped headline & callout */}
              <div className="bg-maritime-900 text-white rounded-2xl p-8 shadow-xl border border-maritime-800 space-y-3">
                <h3 className="text-xl font-bold text-white tracking-tight">
                  Skal du have flyttet din båd?
                </h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Jeg tilbyder bådtransport og flytning af både i Mårslet, Aarhus, Horsens og i hele Østjylland. Udfyld formularen med dine oplysninger, så vender jeg tilbage med en plan og et uforpligtende tilbud.
                </p>
              </div>
            </div>

            {/* Right: Full Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm
                title="Udfyld kontaktformularen her"
                subtitle="Send en besked med dine oplysninger – jeg besvarer din henvendelse hurtigst muligt."
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
